import { ReactSVG } from 'react-svg'
import styles from '@/layouts/MenuSide/index.module.less'
import { Tooltip } from 'antd'
import { useFileUrlPrefix } from 'shj-utils'

export default function useMenuCovert() {
  const [imagePrefix] = useFileUrlPrefix()

  const convertIcon = icon => {
    let nextIcon = icon
    if (icon && /.+\.(.+)$/.test(icon)) {
      if (/\.svg$/.test(icon)) {
        nextIcon = (
          <ReactSVG
            className={styles.svgCon}
            src={icon.startsWith('http') ? icon : imagePrefix + icon}
          />
        )
      } else {
        nextIcon = (
          <img
            src={icon.startsWith('http') ? icon : imagePrefix + icon}
            width={16}
            alt="icon"
            style={{
              marginRight: 3,
              // filter: `drop-shadow(${colorPrimary} 100px 0)`,
              // transform: 'translateX(-100px)',
            }}
          />
        )
      }
    } else {
      nextIcon = null
    }
    return nextIcon
  }

  const convertLabel = (label, level = 0, hasChildren = false) => {
    let nextLabel = label
    // 文本超出显示tips
    if (level * 12 + nextLabel?.length * 14 > (hasChildren ? 110 : 140)) {
      nextLabel = (
        <Tooltip title={nextLabel} placement="right">
          {nextLabel}
        </Tooltip>
      )
    }
    return nextLabel
  }

  const convertMenu = menuData => {
    return menuData.map(item => {
      item.icon = convertIcon(item.app.menuLogo || item.app.icon || null) // 兼容
      item.label = convertLabel(item.app.name)
      item.key = item.id
      return item
    })
  }

  return {
    convertIcon,
    convertLabel,
    convertMenu,
  }
}
